import { render, staticRenderFns } from "./Programa-insNetsuite.vue?vue&type=template&id=51bfe520"
import script from "./Programa-insNetsuite.vue?vue&type=script&lang=js"
export * from "./Programa-insNetsuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports